import { FuelButton, FuelSign, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import actions from 'constants/reducers';
import { useAppContext } from 'hooks/useAppContext';
import { usePayPerUseExtraTruckers } from 'hooks/usePayPerUseExtraTruckers';
import { useUnlockSuggestedTruckersEvents } from 'hooks/useUnlockSuggestedTruckersEvents';
import React from 'react';
import * as Styled from './styled';

export const BannerPayPerUser = () => {
  const { dispatch } = useAppContext();

  const { lockedTruckersAmount } = usePayPerUseExtraTruckers();
  const { sendUnlockSuggestedTruckersEvent } = useUnlockSuggestedTruckersEvents();

  const handleOpenPurchaseExtraTruckersModal = () =>
    dispatch({ type: actions.modals.setOpenPurchaseExtraSuggestedTruckers });

  const handleClick = () => {
    handleOpenPurchaseExtraTruckersModal();
    sendUnlockSuggestedTruckersEvent('button-banner-open-modal');
  };

  return (
    <Styled.BannerWrapper>
      <Styled.BannerContent>
        <FuelFlex defaultProps={{ width: '100%', gap: 'km4', alignItems: 'center' }}>
          <FuelSign
            size="medium"
            color="inverted"
            colorIntensity="strong"
            icon="lock"
            iconStyle="filled"
            data-testid="locked-sign"
          />
          <FuelTypography size="body-sm" weight="medium">
            Desbloqueie agora e conecte-se com até mais {lockedTruckersAmount} motoristas! Tenha acesso a contatos
            verificados, selecionados por IA e com maior exclusividade.
          </FuelTypography>
        </FuelFlex>

        <FuelButton variant="secondary" size="small" onClick={handleClick}>
          Desbloquear motoristas
        </FuelButton>
      </Styled.BannerContent>
    </Styled.BannerWrapper>
  );
};
